import { ApplicationBranding } from "@into-discovery/browsewebshared";
import color from "../styles/_helpers/branding.module.scss";

export const appBranding: ApplicationBranding = {
  primaryColor: color.primary,
  primaryHoverColor: color.primaryHover,
  primaryActiveColor: color.primaryActive
};
